import React from 'react';
import { Avatar } from '@mui/material';
import { Link } from 'react-router-dom';
import { useStore } from 'react-redux';

const MerchantProfile: React.FC = () => {
  const store = useStore();

  return (
    <Link to="/dashboard/profile">
      <div className="flex items-center justify-center space-x-4 py-2">
        <Avatar sx={{ width: 45, height: 45, bgcolor: '#4f46e5' }} className="bg-indigo-800">
          {store.getState().auth?.user?.company?.name?.charAt(0)?.toUpperCase()}
        </Avatar>
        <div className="space-y-1">
          <div>{store.getState().auth?.user?.company?.name ?? ''}</div>
          <div>{store.getState().auth?.user?.company?.contact_number ?? ''}</div>
        </div>
      </div>
    </Link>
  );
};

export default MerchantProfile;
